import React, { useCallback, useMemo } from 'react'

import Padding from 'components/Editor/Toolbar/Padding'
import { LayoutScroll } from 'components/LayoutPage'
import { FormField } from 'components/formKit'
import { Typography } from 'components/uiKit/Typography'
import { BrandGoBack } from 'services/Branding/components'
import { FEEDBACK_SCHEMA_FIELDS } from 'services/Branding/fieldConfigs'
import { useUpdateSchema } from 'services/Branding/hooks'
import { BrandFormEnum } from 'services/Branding/types'
import { t } from 'services/Translation'

import type { TestGroupingFormBrandType } from './testGroupingTypes'

const TestGroupingFormFeedback: TestGroupingFormBrandType = ({ device, subConfigs, setForm }) => {
  const stylePath = useMemo(() => ['feedback', device], [device])
  const schema = useUpdateSchema(stylePath, subConfigs, FEEDBACK_SCHEMA_FIELDS)

  const handleGoBack = useCallback(() => setForm?.(BrandFormEnum.STYLE), [setForm])

  return (
    <LayoutScroll sizeAutoCapable>
      <Padding bottom bottomSpace gap sides>
        <BrandGoBack onClick={handleGoBack} />
        <Typography weight='medium'>{t('elements.testAnswerFeedback.tags.correct')}</Typography>
        <FormField config={schema.correct.backgroundImage} />
        <FormField config={schema.correct.backgroundColor} />
        <FormField config={schema.correct.color} />
        <FormField config={schema.incorrect.backgroundImage} />
        <FormField config={schema.incorrect.backgroundColor} />
        <FormField config={schema.incorrect.color} />
        <FormField config={schema.common__var.width} />
        <FormField config={schema.common__var.height} />

        <Typography weight='medium'>{t('elements.testAnswerFeedback.tags.common')}</Typography>
        <FormField config={schema.common.borderRadius} />
        <FormField config={schema.common.displayIcon} />

        <Typography weight='medium'>{t('elements.testFeedback.tags.infoPanel')}</Typography>
        <FormField config={schema.info.backgroundImage} />
        <FormField config={schema.info.backgroundColor} />
        <FormField config={schema.info.borderStyle} />
        <FormField config={schema.info.borderColor} />
        <FormField config={schema.info.borderWidth} />

        <Typography weight='medium'>{t('elements.testFeedback.tags.successPanel')}</Typography>
        <FormField config={schema.success.backgroundImage} />
        <FormField config={schema.success.backgroundColor} />
        <FormField config={schema.success.borderStyle} />
        <FormField config={schema.success.borderColor} />
        <FormField config={schema.success.borderWidth} />

        <Typography weight='medium'>{t('elements.testFeedback.tags.failPanel')}</Typography>
        <FormField config={schema.fail.backgroundImage} />
        <FormField config={schema.fail.backgroundColor} />
        <FormField config={schema.fail.borderStyle} />
        <FormField config={schema.fail.borderColor} />
        <FormField config={schema.fail.borderWidth} />

        <Typography weight='medium'>{t('style.effects')}</Typography>
        <FormField config={schema.effects.boxShadow} />

        <Typography weight='medium'>{t('elements.testAnswerFeedback.tags.indents')}</Typography>
        <FormField config={schema.indents.marginBottom} />
      </Padding>
    </LayoutScroll>
  )
}

export default React.memo(TestGroupingFormFeedback) as typeof TestGroupingFormFeedback
